import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableLiveRatesWithDimensions = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableLiveRatesWithDimensions);
};
